import React from 'react';

export const EmailTickIcon = () => {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.45622 0C4.2419 0 0 4.2419 0 9.45622C0 14.6705 4.2419 18.9124 9.45622 18.9124C14.6705 18.9124 18.9124 14.6705 18.9124 9.45622C18.9124 4.2419 14.6705 0 9.45622 0ZM9.38451 12.1505C9.07955 12.4554 8.67845 12.6075 8.27577 12.6075C7.87309 12.6075 7.46805 12.4538 7.15994 12.1465L4.96767 10.022L6.06538 8.88964L8.26631 11.0228L12.8439 6.53031L13.9503 7.65324L9.38451 12.1505Z"
                fill="#1E3F80"/>
        </svg>
    )
}